import { UseDisclosureReturn } from '@chakra-ui/react';
import { useAuth, useHookForm, BaseFormPopover } from '@cks-internal/react-base';
import { useWatch } from 'react-hook-form';
import { LobbyType } from '../../../features/workflow/types';
import { useWorkflowSocket } from '../../../features/workflow/hub/useWorkflowSocket';
import { timeOptionsSelect } from '../../../features/workflow/utils/timeOptionsSelect';
import { ApplicationRoles } from '../../../constants/applicationRoles.ts';
import { useGroupType } from '../../../features/workflow/utils/useGroupType';
import { useGroupName } from '../../../features/workflow/utils/useGroupName';
import { ReactNode, useMemo } from 'react';
import { ScheduleTable } from '../ScheduleTable';

type JoinWorkflowType = {
  group: LobbyType | undefined;
  shift?: string;
  lunch?: string;
  end?: string;
  isCoordinator?: boolean;
  isSpectating?: boolean;
};
export const JoinWorkflowForm = (props: { disclosure: UseDisclosureReturn; trigger: ReactNode }) => {
  const auth = useAuth();
  const group = useGroupType();
  const wfType = useGroupName(group);
  const { formMethods, fieldHelper } = useHookForm<JoinWorkflowType>({ group });
  const invoke = useWorkflowSocket((r) => r.invoke);
  const isSpectating = useWatch({
    control: formMethods.control,
    name: 'isSpectating'
  });
  const fields = useMemo(() => {
    const toReturn = [
      fieldHelper
        .switchInput('isCoordinator')
        .withRenderIf(() => auth.isInRole([ApplicationRoles.inboxCoordinator]) && !isSpectating),
      fieldHelper
        .switchInput('isSpectating')
        .withRenderIf(() =>
          auth.isInRole([ApplicationRoles.inboxCoordinator, ApplicationRoles.resManager, ApplicationRoles.developer])
        ),
      fieldHelper
        .selectInput('shift', { items: timeOptionsSelect() })
        .withLabel('Shift End')
        .withInputProps({ disableSort: true })
        .withValidation({ required: {} })
        .withRenderIf(() => !isSpectating),
      fieldHelper
        .selectInput('lunch', { items: timeOptionsSelect() })
        .withLabel('Break Start')
        .withRenderIf(() => !isSpectating)
        .withInputProps({ disableSort: true }),
      fieldHelper
        .selectInput('end', { items: timeOptionsSelect() })
        .withLabel('Break End')
        .withRenderIf(() => !isSpectating)
        .withInputProps({ disableSort: true })
    ];
    if (group == undefined) {
      toReturn.push(
        fieldHelper
          .selectInput('group', {
            items: [
              {
                Label: 'Folio',
                Value: LobbyType.Folio
              },
              {
                Label: 'Inbox',
                Value: LobbyType.Inbox
              }
            ]
          })
          .withValidation({ required: {} })
      );
    }
    return toReturn;
  }, [group, isSpectating]);
  return (
    <BaseFormPopover
      disclosure={props.disclosure}
      trigger={props.trigger}
      formMethods={formMethods}
      header={`Join ${wfType} Worksdfflow Tool`}
      fields={fields}
      onSubmit={async (d) => {
        await invoke('Join', d.group, d.shift ?? '', d.lunch, d.end, d.isCoordinator, d.isSpectating);
        props.disclosure.onClose();
      }}>
      <ScheduleTable hideActions={true} hideSearch={true} hideSort={true} />
    </BaseFormPopover>
  );
};
